<!-- eslint-disable no-tabs -->
<template>
<div>
  <div class="panel-notification is-scroll"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loadCheck"
      infinite-scroll-throttle-delay="400"
      infinite-scroll-distance="10"
  >
  <div v-if = "exceptionType !== EXCEPTION_TYPE.INEGRATION">
    <div
      class="list-notification pointer"
      :class="{ 'is-active': isSelectedItem(item.entity_no) }"
			v-for="(item, index) in data"
			:key="'notification-list-' + index"
			@click="selectItem(item)"
    >
      <i class="icon-list">
        <svgicon name="loading_split" width="14" height="14" :original="true" />
      </i>
      <div class="list-content">
        <div>
          <p>
            <strong>
              {{item.entity_no}}
            </strong>
          </p>
          <p>
            {{$t('Source')}} :
            <strong>{{item.source}}</strong>
					</p>
					<p>
						{{$t('Destination')}}:
						<strong>{{item.destination}}</strong>
          </p>
        </div>
        <div class="ml-auto text-muted mr-10">{{item.expected_delivery_date}}</div>
      </div>
    </div>
    </div>
    <div v-if = "exceptionType === EXCEPTION_TYPE.INEGRATION">
    <div
      class="list-notification pointer"
      :class="{ 'is-active': isSelectedlog(item.entity_id, item.api_name) }"
			v-for="(item, index) in data"
			:key="'notification-list-' + index"
			@click="selectItem(item)"
    >
      <i class="icon-list">
        <svgicon name="loading_split" width="14" height="14" :original="true" />
      </i>
      <div class="list-content">
        <div>
          <p>
            <strong>
              {{item.entity_id}} : {{item.error_message}}
            </strong>
          </p>
          <p>
						{{$t('INDENT_ENTITY_ID')}}
						<strong>{{item.entity_type}}</strong>
          </p>
					<p>
						{{$t('INDENT_ERROR_INTERFACE')}}
						<strong>{{item.api_name}}</strong>
          </p>
        </div>
        <div class="ml-auto text-muted mr-10">{{item.updated_at}}</div>
      </div>
    </div>
    </div>
    </div>
    <div v-if="!data.length && isLisLoadingCompleted" class="status-msg my-sm" size="small" text="top-left" style="width:45%;">
      <div class="status-content">
        <span class="status-inner">
          <img :src="NoData" width="200" height="180" class="img-responsive" alt=""/>
          <p style="width:100px; left:20px;">No data found</p>
        </span>
      </div>
    </div>
    <div v-if="!isLisLoadingCompleted" class="status-msg my-md" style="width:45%;">
      <span>
        <img :src="LoaderCommon" width="240" class="img-responsive" alt="" />
      </span>
    </div>
</div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import NoData from '@common/asset/images/status-no-data.png';
// eslint-disable-next-line import/no-extraneous-dependencies
import LoaderCommon from '@common/asset/images/loader-common.gif';
import { EXCEPTION_TYPE } from '@/constants/exception-data';

export default {
  name: 'exception-list',
  props: {
    exceptionType: {
      type: Number,
    },
    data: {
      type: Array,
    },
    isLisLoadingCompleted: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedItem: null,
      EXCEPTION_TYPE,
      NoData,
      LoaderCommon,
    };
  },
  computed: {
    isSelectedItem() {
      return entityNo => !!(this.selectedItem && (this.selectedItem.entity_no || this.selectedItem.entity_id) === entityNo);
    },
    isSelectedlog() {
      return ((entityNo, apiName) => !!(this.selectedItem && (this.selectedItem.entity_no || this.selectedItem.entity_id) === entityNo) &&
        !!(this.selectedItem && (this.selectedItem.api_name) === apiName));
    },
  },
  methods: {
    loadMore() {
      this.$emit('load-more');
    },
    selectItem(item) {
      this.selectedItem = item;
      this.$emit('select-item', this.selectedItem);
    },
  },
};
</script>

